export default {
  de: {
    add: 'Partei hinzufügen',
    types: 'Wahltypen',
    parties: 'Parteien',
    presidents: 'Bundespräsidenten',
    name: 'Name',
    parent: 'gruppiert unter',
    color: 'Farbcode',
    updatedAt: 'zuletzt bearbeitet am',
    editor: 'zuletzt bearbeitet von',
  },
};
